/** @jsx h */

import { h } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.scss';

import IconClose from '../../../IconClose';

const BtnClose = ({ onClick, className, white }) => {
    const btnClasses = classNames({
        [styles.btnClose]: true,
        [styles.white]: white,
        [className]: !!className,
    });
    return (
        <div className={btnClasses} onClick={onClick}>
            <IconClose />
        </div>
    );
};

BtnClose.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    white: PropTypes.bool,
};

BtnClose.defaultProps = {
    onClick: () => {},
    className: '',
    white: false,
};

export default BtnClose;
